"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var adhere_ui_conditionalrender_1 = __importDefault(require("@baifendian/adhere-ui-conditionalrender"));
var Auto_1 = __importDefault(require("./Auto"));
var Fixed_1 = __importDefault(require("./Fixed"));
var FlexLayout_1 = __importDefault(require("./FlexLayout"));
/**
 * VerticalFlexLayout
 * @constructor
 * @param props
 */
var VerticalFlexLayout = (0, react_1.memo)(function (props) {
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    _b = props.style,
    style = _b === void 0 ? {} : _b,
    _c = props.topClassName,
    topClassName = _c === void 0 ? '' : _c,
    _d = props.topStyle,
    topStyle = _d === void 0 ? {} : _d,
    _e = props.rightClassName,
    rightClassName = _e === void 0 ? '' : _e,
    _f = props.rightStyle,
    rightStyle = _f === void 0 ? {} : _f,
    _g = props.bottomClassName,
    bottomClassName = _g === void 0 ? '' : _g,
    _h = props.bottomStyle,
    bottomStyle = _h === void 0 ? {} : _h,
    _j = props.leftClassName,
    leftClassName = _j === void 0 ? '' : _j,
    _k = props.leftStyle,
    leftStyle = _k === void 0 ? {} : _k,
    _l = props.mainClassName,
    mainClassName = _l === void 0 ? '' : _l,
    _m = props.mainStyle,
    mainStyle = _m === void 0 ? {} : _m,
    _o = props.mainAutoWrapClassName,
    mainAutoWrapClassName = _o === void 0 ? '' : _o,
    _p = props.mainAutoStyle,
    mainAutoStyle = _p === void 0 ? {} : _p,
    _q = props.mainWrapClassName,
    mainWrapClassName = _q === void 0 ? '' : _q,
    _r = props.mainWrapStyle,
    mainWrapStyle = _r === void 0 ? {} : _r,
    renderTop = props.renderTop,
    renderRight = props.renderRight,
    renderBottom = props.renderBottom,
    renderLeft = props.renderLeft,
    renderMain = props.renderMain,
    _s = props.topProps,
    topProps = _s === void 0 ? {} : _s,
    _t = props.rightProps,
    rightProps = _t === void 0 ? {} : _t,
    _u = props.bottomProps,
    bottomProps = _u === void 0 ? {} : _u,
    _v = props.leftProps,
    leftProps = _v === void 0 ? {} : _v,
    _w = props.mainProps,
    mainProps = _w === void 0 ? {} : _w,
    _x = props.mainAutoWrapProps,
    mainAutoWrapProps = _x === void 0 ? {} : _x,
    children = props.children,
    attrs = __rest(props, ["className", "style", "topClassName", "topStyle", "rightClassName", "rightStyle", "bottomClassName", "bottomStyle", "leftClassName", "leftStyle", "mainClassName", "mainStyle", "mainAutoWrapClassName", "mainAutoStyle", "mainWrapClassName", "mainWrapStyle", "renderTop", "renderRight", "renderBottom", "renderLeft", "renderMain", "topProps", "rightProps", "bottomProps", "leftProps", "mainProps", "mainAutoWrapProps", "children"]);
  var topElement = (0, react_1.useMemo)(function () {
    return react_1.default.createElement(adhere_ui_conditionalrender_1.default, {
      conditional: !!renderTop
    }, function () {
      return react_1.default.createElement(Fixed_1.default, __assign({
        className: (0, classnames_1.default)(topClassName),
        style: topStyle !== null && topStyle !== void 0 ? topStyle : {},
        fit: true
      }, topProps !== null && topProps !== void 0 ? topProps : {}), renderTop);
    });
  }, [renderTop, topClassName, topStyle, topProps]);
  var mainElement = (0, react_1.useMemo)(function () {
    return react_1.default.createElement(adhere_ui_conditionalrender_1.default, {
      conditional: !!renderMain
    }, function () {
      return react_1.default.createElement(Auto_1.default, __assign({
        className: (0, classnames_1.default)(mainAutoWrapClassName),
        style: mainAutoStyle !== null && mainAutoStyle !== void 0 ? mainAutoStyle : {},
        fit: true,
        autoFixed: true
      }, mainAutoWrapProps !== null && mainAutoWrapProps !== void 0 ? mainAutoWrapProps : {}), react_1.default.createElement(FlexLayout_1.default, {
        direction: "horizontal",
        className: (0, classnames_1.default)(mainWrapClassName),
        style: mainWrapStyle !== null && mainWrapStyle !== void 0 ? mainWrapStyle : {}
      }, react_1.default.createElement(adhere_ui_conditionalrender_1.default, {
        conditional: !!renderLeft
      }, function () {
        return react_1.default.createElement(Fixed_1.default, __assign({
          className: (0, classnames_1.default)(leftClassName),
          style: leftStyle !== null && leftStyle !== void 0 ? leftStyle : {},
          fit: true
        }, leftProps !== null && leftProps !== void 0 ? leftProps : {}), renderLeft);
      }), react_1.default.createElement(Auto_1.default, __assign({
        autoFixed: true,
        fit: true,
        className: (0, classnames_1.default)(mainClassName),
        style: mainStyle !== null && mainStyle !== void 0 ? mainStyle : {}
      }, mainProps !== null && mainProps !== void 0 ? mainProps : {}), renderMain), react_1.default.createElement(adhere_ui_conditionalrender_1.default, {
        conditional: !!renderRight
      }, function () {
        return react_1.default.createElement(Fixed_1.default, __assign({
          className: (0, classnames_1.default)(rightClassName),
          style: rightStyle !== null && rightStyle !== void 0 ? rightStyle : {},
          fit: true
        }, rightProps !== null && rightProps !== void 0 ? rightProps : {}), renderRight);
      })));
    });
  }, [renderMain, mainAutoWrapClassName, mainAutoStyle, mainAutoWrapProps, mainWrapClassName, mainWrapStyle, renderLeft, leftClassName, leftStyle, leftProps, mainClassName, mainStyle, mainProps, renderRight, rightClassName, rightStyle, rightProps]);
  var bottomElement = (0, react_1.useMemo)(function () {
    return react_1.default.createElement(adhere_ui_conditionalrender_1.default, {
      conditional: !!renderBottom
    }, function () {
      return react_1.default.createElement(Fixed_1.default, __assign({
        className: (0, classnames_1.default)(bottomClassName),
        style: bottomStyle !== null && bottomStyle !== void 0 ? bottomStyle : {},
        fit: true
      }, bottomProps !== null && bottomProps !== void 0 ? bottomProps : {}), renderBottom);
    });
  }, [renderBottom, bottomClassName, bottomStyle, bottomProps]);
  return react_1.default.createElement(FlexLayout_1.default, __assign({}, attrs, {
    className: (0, classnames_1.default)(className),
    style: style !== null && style !== void 0 ? style : {},
    direction: "vertical"
  }), topElement, mainElement, bottomElement);
});
VerticalFlexLayout.displayName = 'VerticalFlexLayout';
exports.default = VerticalFlexLayout;